import { Component, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { UserInfos } from '../../services/Ebootis.Queries/UserInfos';
import { IZbsApp } from '../../services/Ebootis.ServiceProxies/IZbsApp';

@Component({
  selector: 'app-user-info',
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.scss']
})
export class UserInfoComponent implements OnInit {
  m_userInfos: UserInfos.Result;
  m_usedBudget: IZbsApp.UsedBudget;
  constructor(private userInfosQuery: UserInfos, private zbsApp: IZbsApp) { }

  ngOnInit() {
    this.userInfosQuery.query().pipe(take(1)).subscribe({
      next: (userInfos) => this.m_userInfos = userInfos
    });
    this.zbsApp.getUsedBudget().pipe(take(1)).subscribe({
      next: (budget) => {
        this.m_usedBudget = budget;
      }
    })
  }

}
